<div class="report">
  @if (report !== undefined) {
    <mat-card class="report">
      <div [style.backgroundImage]="'url( ./assets/' + report.i + ')'" class="main-content">
        @if (report.u !== undefined && report.n !== undefined) {
          <button
            type="button"
            mat-mini-fab
            color="primary"
            (click)="exportAsPdf(report.u, report.n)"
            class="button-report">
            <i class="far fa-file-pdf"></i>
          </button>
        }
        @if (report.e !== undefined && report.n !== undefined) {
          <button
            type="button"
            mat-mini-fab
            color="primary"
            (click)="exportAsExcel(report.e, report.n)"
            class="button-export">
            <i class="far fa-file-excel"></i>
          </button>
        }
        @if (!fieldConfig.noLabel && fieldConfig.label !== undefined) {
          <p class="title">{{ fieldConfig.label }}</p>
        }
        @for (table of report.tbl; track table) {
          <div class="table adjust-table">
            <div class="title">{{ table.t }}</div>
            <table [ngClass]="getFormat(table.f)" [style]="getTableWidth(table)">
              @for (row of table.r; track row) {
                <tr [ngClass]="getRowFormat(table, row)" class="adjust-row">
                  @for (col of row.c; track col; let idx = $index) {
                    <td [ngClass]="getColFormat(table, row, col)" [style]="getColWidth(table, row, col, idx)">
                      @if (col.i !== undefined && col.w === undefined) {
                        <img [src]="col.i" />
                      }
                      @if (col.i !== undefined && col.w !== undefined) {
                        <img [src]="col.i" [width]="col.w" [height]="col.h" />
                      }
                      @if (col.v !== undefined) {
                        <span>{{ col.v }}</span>
                      }
                      @if (col.c !== undefined) {
                        <app-chart-form-field [data]="col.c" [canDownload]="false"> </app-chart-form-field>
                      }
                    </td>
                  }
                </tr>
              }
            </table>
          </div>
        }
      </div>
    </mat-card>
  }
</div>
